import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Dropdown from "../dropdown";
import i18next from "i18next";

function LanguageDropdown() {
  const [language, SetLanguage] = useState();
  const { i18n, t } = useTranslation();
  const [selectedLanguage, SetSelectedLanguage] = useState();

  useEffect(() => {
    let language = localStorage.getItem("i18nextLng");
    if (localStorage.getItem("i18nextLng")?.length > 2) {
      i18next.changeLanguage("en");
    }
    if (language === "zh") {
      i18next.changeLanguage("zh");
      SetSelectedLanguage(languageSelection[1]);
    } else {
      i18next.changeLanguage("en");
      SetSelectedLanguage(languageSelection[0]);
    }
  }, []);

  const languageSelection = [
    { id: "1", label: "English", value: "en" },
    { id: "2", label: "简体中文", value: "zh" },
  ];

  const handleLanguageChange = (e) => {
    if (e === "1") {
      i18n.changeLanguage("en");
    } else {
      i18n.changeLanguage("zh");
    }
  };

  return (
    <>
      {selectedLanguage && (
        <Dropdown
          data={languageSelection}
          selectedItem={selectedLanguage}
          onChange={handleLanguageChange}
          placeholder="Change Language"
        />
      )}
    </>
  );
}

export default LanguageDropdown;
